import React, { useContext, useState } from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'
import {IoMdArrowDropdown} from 'react-icons/io'
import {IoChevronBackOutline} from  'react-icons/io5'
import {BiCheck} from  'react-icons/bi'
import Renderif from './renderif'
import DropDown, { DropDownOption } from './dropdown'
import CheckBox from './checkbox'
import { BsArrowRight} from 'react-icons/bs'
import { Service } from '../services/api'
import { AuthContext } from '../context/auth_context'
import { AlertContext } from '../context/alert_context'
import Loader from './loader'


export default function Quiz({...props}) {
    const {user} = useContext(AuthContext)
    const {notify} = useContext(AlertContext)
    const [state, setState] = useState({
        step:0,
        selected_date:null,
        onboarding: {},
        intereses_selected:[]
    })

    const intereses = [
        {
            img:'./assets/mujer2.png',
            title:'Mujer',
        },
        {
            img:'./assets/Padres de Familia.png',
            title:'Padres de <br /> Familia',
        },
        {
            img:'./assets/Adolescente.png',
            title:'Adolecente',
        },
        {
            img:'./assets/Familia.png',
            title:'Familia',
        },
        {
            img:'./assets/Matrimonio.png',
            title:'Matrimonio',
        },
        {
            img:'./assets/Valores.png',
            title:'Valores',
        },
        {
            img:'./assets/Vida Plena.png',
            title:'Vida Plena',
        },
        {
            img:'./assets/Infancia.png',
            title:'Infancia',
        },
        {
            img:'./assets/comunicacion.png',
            title:'Comunicación',
        },
        {
            img:'./assets/trabajo.png',
            title:'Trabajo',
        },
        {
            img:'./assets/Profesionalismo.png',
            title:'Profesionalismo',
        },
        {
            img:'./assets/inteligencia emocional.png',
            title:'Inteligencia <br /> Emocional',
        },
        {
            img:'./assets/Administracion de Tiempo.png',
            title:'Adminsitración <br /> del Tiempo',
        },
        {
            img:'./assets/Equilibrio Familiar.png',
            title:'Equilibrio <br /> Familiar',
        },
        {
            img:'./assets/superacion Personal.png',
            title:'Superación <br /> Personal',
        },
        {
            img:'./assets/Autoestima.png',
            title:'Autoestima',
        },
        {
            img:'./assets/Duelos.png',
            title:'Duelos',
        },
        {
            img:'./assets/Salud Mental.png',
            title:'Salud Mental',
        },
        {
            img:'./assets/depresion.png',
            title:'Depresión',
        },
        {
            img:'./assets/ansiedad.png',
            title:'Ansiedad',
        },

    ];

    const updateOboarding = async () => {
        setState({...state, loafing:true})
        let body = {
            data:JSON.stringify(state.onboarding)
        }
        let update = await Service('PUT', `user/${user.id}/onboarding`, body);
        if(update === 200){
            notify({title:'Intereses', message:'¡Listo! Ya puedes continuar navegando por BienVivir', type:'success'})
    
        }else{
            notify({title:'Intereses', message:'¡Listo! Ya puedes continuar navegando por BienVivir', type:'success'})
       
        }
       props.onClose()
    }

  return (
    <>
    <Renderif isTrue={state.loading}>
        <Loader></Loader>
    </Renderif>
    <div className='bv-quiz justify-content-center align-items-center pb-2'>
         

        <Renderif isTrue={state.step === 0}>
            <div className='bv-modal bg-white justify-content-end overflow-hidden shadow' style={{backgroundImage:'url(./assets/o1.png)'}}>
                <div className='bg-white r-contents shadow'>

                    <div className='d-flex justify-content-center'>
                        <div className='bv-pill bv-pill--primary'>Paso 1</div>
                    </div>

                    <div className='px-4 pt-3 pb-2 d-flex align-items-center justify-content-center'>
                        <div className='f-24 bold text-center text-dark'>¡Bienvenido a <span className='text-primary'>Bien Vivir</span>! <br></br>para empezar,<br></br>cuentame un poco de ti.</div>
                    </div>

                    {/* <div className='d-flex py-3 px-4'>
                        <div className='col'></div>
                        <div className='bv-pill bv-pill--primary cursor-pointer' onClick={()=>{
                                setState({...state, step:state.step + 1})
                        }}>Continuar</div>
                    </div> */}
                    
                    <div className='d-flex py-3 px-4'>

                        <div className='col'></div>
                        <div className='bv-icon bv-icon--big r-100 bg-dark cursor-pointer' onClick={()=>{
                                setState({...state, step:state.step + 1})
                        }}>
                            <BsArrowRight color='white' size={24}></BsArrowRight>
                        </div>
                    </div>

                    <StepBars step={state.step}></StepBars>
                    
                </div>
            </div>
        </Renderif>
        <Renderif isTrue={state.step === 1}>
            <div className='bv-modal bg-white justify-content-end overflow-hidden shadow' style={{backgroundImage:'url(./assets/o2.png)'}}>
                <div className='bg-white r-contents shadow'>

                    <div className='d-flex justify-content-center'>
                        <div className='bv-pill bv-pill--primary'>Paso 2</div>
                    </div>

                    <div className='px-4 pt-3 pb-2 d-flex align-items-center justify-content-center'>
                        <div className='f-18 bold  text-gray'>¿Cuál es tu nivel máximo de estudios?</div>
                    </div>

                    <div className='px-4 pb-3'>
                        <div className='mt-2'>
                            <DropDown 
                                title='Seleccione Nivel de Estudios'
                                direction='top-left'
                                open={false}
                                // defaultValue={0} 

                                _onChange={(evt)=>{
                                state.onboarding.estudiosMax = evt.label;
                                console.log(evt)
                            }}>
                                <DropDownOption value={0} label="NIVEL BÁSICO">
                                    <div className='f-14 text-gray'>NIVEL BÁSICO</div>
                                </DropDownOption>
                                <DropDownOption value={1} label="PREPARATORIA">
                                    <div className='f-14 text-gray'>PREPARATORIA</div>
                                </DropDownOption>
                                <DropDownOption value={2} label="LICENCIATURA">
                                    <div className='f-14 text-gray'>LICENCIATURA</div>
                                </DropDownOption>
                                <DropDownOption value={3} label="MAESTRÍA">
                                    <div className='f-14 text-gray'>MAESTRÍA</div>
                                </DropDownOption>
                         
                             
                            </DropDown>
                        </div>
                    </div>

                    <div className='d-flex pb-3 px-4'>

                        <div className='col'></div>
                        <div className='bv-icon bv-icon--big r-100 bg-dark cursor-pointer' onClick={()=>{
                                setState({...state, step:state.step + 1})
                        }}>
                            <BsArrowRight color='white' size={24}></BsArrowRight>
                        </div>
                    </div>

                    <StepBars step={state.step}></StepBars>
                </div>
            </div>
        </Renderif>
        <Renderif isTrue={state.step === 2}>
            <div className='bv-modal bg-white justify-content-end overflow-hidden shadow' style={{backgroundImage:'url(./assets/o3.png)'}}>
                <div className='bg-white r-contents shadow'>

                    <div className='d-flex justify-content-center'>
                        <div className='bv-pill bv-pill--primary'>Paso 3</div>
                    </div>

                    <div className='px-4 pt-3 pb-2 d-flex align-items-center justify-content-center'>
                        <div className='f-18 bold  text-gray'>¿Cuál es tú estado civil?</div>
                    </div>

                    <div className='px-4 pb-3'>
                        <div className='mt-2'>
                            <DropDown 
                                title='Seleccione Estado Civil'
                                direction='top-left'
                                open={false}
                                // defaultValue={0} 
                                _onChange={(evt)=>{
                                    state.onboarding.estadoCivil = evt.label;
                                console.log(evt)
                            }}>
                                <DropDownOption value={0} label="SOLTERO">
                                    <div className='f-14 text-gray'>SOLTERO</div>
                                </DropDownOption>
                                <DropDownOption value={1} label="CASADO">
                                    <div className='f-14 text-gray'>CASADO</div>
                                </DropDownOption>
                                <DropDownOption value={2} label="DIVORCIADO">
                                    <div className='f-14 text-gray'>DIVORCIADO</div>
                                </DropDownOption>
                                <DropDownOption value={3} label="UNIÓN LIBRE">
                                    <div className='f-14 text-gray'>UNIÓN LIBRE</div>
                                </DropDownOption>
                                <DropDownOption value={4} label="VIUDO">
                                    <div className='f-14 text-gray'>VIUDO</div>
                                </DropDownOption>
                             
                             
                            </DropDown>
                        </div>
                    </div>

                    <div className='d-flex pb-3 px-4'>

                        <div className='col'></div>
                        <div className='bv-icon bv-icon--big r-100 bg-dark cursor-pointer' onClick={()=>{
                                setState({...state, step:state.step + 1})
                        }}>
                            <BsArrowRight color='white' size={24}></BsArrowRight>
                        </div>
                    </div>

                    <StepBars step={state.step}></StepBars>
                </div>
            </div>
        </Renderif>
        <Renderif isTrue={state.step === 3}>
            <div className='bv-modal bg-white justify-content-end overflow-hidden shadow' style={{backgroundImage:'url(./assets/o4.png)'}}>
                <div className='bg-white r-contents shadow'>

                    <div className='d-flex justify-content-center'>
                        <div className='bv-pill bv-pill--primary'>Paso 4</div>
                    </div>

                    <div className='px-4 pt-3 pb-2 d-flex align-items-center justify-content-center'>
                        <div className='f-18 bold  text-gray'>¿Cuál es la edad de tus hijos?</div>
                    </div>

                    <div className='px-4 pb-3'>
                        <div className='mt-2'>
                            <DropDown 
                                title='Seleccione Edad de tus hijos'
                                direction='top-left'
                                open={false}
                                // defaultValue={0} 
                                _onChange={(evt)=>{
                                    state.onboarding.edadHijos = evt.label;
                                console.log(evt)
                            }}>
                                <DropDownOption value={0} label="No tengo">
                                    <div className='f-14 text-gray'>No tengo</div>
                                </DropDownOption>
                                <DropDownOption value={1} label="0 a 5 Años">
                                    <div className='f-14 text-gray'>0 a 5 Años</div>
                                </DropDownOption>
                                <DropDownOption value={2} label="6 a 12 Años">
                                    <div className='f-14 text-gray'>6 a 12 Años</div>
                                </DropDownOption>
                                <DropDownOption value={3} label="13 a 20 Años">
                                    <div className='f-14 text-gray'>13 a 20 Años</div>
                                </DropDownOption>
                                <DropDownOption value={4} label="MAYOR de 20">
                                    <div className='f-14 text-gray'>MAYOR de 20</div>
                                </DropDownOption>
                           
                             
                            </DropDown>
                        </div>
                    </div>

                    <div className='d-flex pb-3 px-4'>

                        <div className='col'></div>
                        <div className='bv-icon bv-icon--big r-100 bg-dark cursor-pointer' onClick={()=>{
                                setState({...state, step:state.step + 1})
                        }}>
                            <BsArrowRight color='white' size={24}></BsArrowRight>
                        </div>
                    </div>

                    <StepBars step={state.step}></StepBars>
                </div>
            </div>
        </Renderif>
        <Renderif isTrue={state.step === 4}>
            <div className='bv-modal bg-white justify-content-end overflow-hidden shadow' style={{backgroundImage:'url(./assets/o.png)'}}>

                <div className='d-flex flex-wrap justify-content-evenly overflow-auto hide-scroll pb-3 mt-3'>
                    {
                        intereses.map((item,i)=> {
                            return (
                            <div key={i} 
                            className={`d-flex flex-column align-items-center mt-1 card cursor-pointer user-select-none 
                            
                            ${state.intereses_selected.filter((interes) => {
                    
                                if(interes.title === item.title){
                                    console.log("SI")
                                    return true
                                } else {
                                    console.log("NOE")
                                    return false
                                }
                            }).length !== 0 ? 'bg-light-strong' : ''}`
                            }

                            
                            onClick={()=>{
                                let exist = state.intereses_selected.filter((interes) => interes.title === item.title).length
                             

                                if(exist > 0){
                                    console.log("REMOVE")
                                    state.intereses_selected =state.intereses_selected.filter((interes) => interes.title !== item.title)
                                   
                                }else{
                                    console.log("ADD")
                                    state.intereses_selected.push(item)
                                }
                   

                                state.onboarding.intereses = state.intereses_selected
                                setState({...state})
                            }}>
                                <img width={95} src={item.img}></img>
                                <div className='col' />
                                <div className='f-12 bold text-center text-gray' dangerouslySetInnerHTML={{__html: item.title}} ></div>
                                <div className='col' />
                            </div>)
                        })
                    }
                </div>

                <div className='bg-white r-contents shadow'>

                    

                    <div className='d-flex justify-content-center'>
                        <div className='bv-pill bv-pill--primary'>Paso 5</div>
                    </div>

                    <div className='px-4 pt-3 pb-2 d-flex align-items-center justify-content-center'>
                        <div className='f-22 bold text-center text-gray'>Selecciona un tema <br></br> de interes.</div>
                    </div>

                   


                    <div className='d-flex pb-3 px-4'>

                        <div className='col'></div>
                        <div className='bv-icon bv-icon--big r-100 bg-dark cursor-pointer' onClick={()=>{
                                // localStorage.setItem('onboarding',0)
                                // props.onClose()
                                updateOboarding()
                                console.log(state.onboarding)
                        }}>
                            <BsArrowRight color='white' size={24}></BsArrowRight>
                        </div>
                    </div>

                    <StepBars step={state.step}></StepBars>
                </div>
            </div>
        </Renderif>
        
     
      
    </div>
    </>
)
}


function StepBars({step}) {
  return (
    <div className='bars'>
        <div className={`bar bar--${step >= 0 ? 'active' : ''}`}></div>
        <div className={`bar bar--${step >= 1 ? 'active' : ''}`}></div>
        <div className={`bar bar--${step >= 2 ? 'active' : ''}`}></div>
        <div className={`bar bar--${step >= 3 ? 'active' : ''}`}></div>
        <div className={`bar bar--${step >= 4 ? 'active' : ''}`}></div>
    
    </div>
  )
}

